import React from 'react';


const WorkConfidenceAlreadyDownloaded = (props) => {

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="text-center">
                    <div>You have already downloaded this file. Would you like to download again?</div>
                </div>
            </div>
        
            <div className="col-md-12">
                <div className="text-center">
                    <br/><br/>
                    <button name="submit" className="btn btn-mid-orange ubuntu" type="button" onClick={props.downloadAgain}>
                        <span>Download</span>
                        <div className={'ripple-container'}></div>
                    </button>
                    &nbsp;
                    <button name="submit" className="btn btn-mid-orange ubuntu" type="button" onClick={props.closeButton}>
                        <span>Close</span>
                        <div className={'ripple-container'}></div>
                    </button>
                </div>
            </div>
        
        </div>
    );
};

export default WorkConfidenceAlreadyDownloaded;